const config = {
    appUserType: 'Studio User'
}

export default config;